/* eslint-disable max-statements-per-line */
/* eslint-disable max-len */
/* eslint-disable complexity */
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {agentDeveloperUtils} from 'wobi-web-common';
import {Button, Card, Dialog, SegmentedControl} from 'wobi-web-common/dist/v2/index.js';
import {FormHelperText, FormControlLabel, Checkbox as MuiCheckbox, useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import YesNoRadioGroup from 'wobi-web-common/dist/components/YesNoRadioGroup';
import {FormattedMessage, useIntl} from 'react-intl';

import {fireGtmEvent} from '../../../utils/marketing.utils';
import {setDetailForm} from '../../../utils/persistOfferDetails';
import {scrollToFirstError} from '../../../utils/scrollToFirstError';
import {toIsoDateValue} from '../../../utils/dateHelpers';
import {PregnancyAndExtremeSportsPopup} from '../../../components/modals/PregnancyAndExtremeSports';
import validationSchema from './helpers/Tab4_helpers/validationSchema';
import SuggestionAddRiderModal from '../../../components/modals/SuggestionAddRider/SuggestionAddRider';

import {getImageByAgent} from '../../../config/agent';
import {clampDateRangesToPolicy} from '../../../utils/dateHelpers';

import moment from 'moment';
import TripDatePicker from '../../../components/TripDatePicker';

import {CoverageBasicPackage} from '../../../components/CoverageBasicPackage';
import {CoverageExtensionRow} from '../../../components/CoverageExtensionRow';
import {CoverageExtensionsList} from '../../../components/CoverageExtensionsList';
import {CoverageConsentFooter} from '../../../components/CoverageConsentFooter';
import {DeviceFields} from '../../../components/DeviceFields';
import {BaggageCoverageOfferModal} from '../../../components/modals/BaggageCoverageOfferModal';
import {RIDER_DISPLAY} from '../../../config/riderDisplay';
import {
  selectExclusiveTraveler,
  updateAllTravelers,
  updateNestedTraveler,
  updateTraveler,
} from './helpers/Tab4_helpers/travelerUpdates';

const presentorImage = getImageByAgent('presentor.png');


const Tab4 = React.memo(
  ({
    className,
    idForAccessibility,
    submitCallback,
    validationCallback,
    formikSetField,
    formikErrors,
    formikValues,
    formikValidateForm,
    actionButton,
    handleOtpOpen,
    showOTP,
  }) => {
    const validationObject = validationSchema;
    useEffect(() => {
      validationCallback(validationObject);
    }, [validationCallback, validationObject]);

    const intl = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDetection, setIsDetection] = React.useState(false);
    const [isLiable, setIsLiable] = React.useState(false);
    const [showSuggestionAddRiderModal, setShowSuggestionAddRiderModal] = React.useState(false);
    const [typeOfSuggestionAddRiderModal, setTypeOfSuggestionAddRiderModal] = React.useState('luggage');
    const [isSuggestionSubmitting, setIsSuggestionSubmitting] = React.useState(false);
    const [isCancellationOfSelfParticipationOnRentedCar, setIsCancellationOfSelfParticipationOnRentedCar] = React.useState(false);
    const [shouldShowPopUp, setShouldShowPopUp] = React.useState(true);
    const [showValidationErrors, setShowValidationErrors] = React.useState(false);
    const visibleFormikErrors = showValidationErrors ? formikErrors : {};
    const openSuggestionAddRiderModal = () => setShowSuggestionAddRiderModal(true);
    const closeSuggestionAddRiderModal = () => setShowSuggestionAddRiderModal(false);

    const calculateDaysChange = (startDate, endDate) => {
      if (!startDate.isValid() || !endDate.isValid()) {
        return 0;
      }
      return endDate.diff(startDate, 'days') + 1;
    };

    const convertToUTCDate = (momentDate) => {
      return new Date(Date.UTC(momentDate.year(), momentDate.month(), momentDate.date(), 12, 0, 0));
    };

    const updateSportDateRange = (traveler, type, isStart, utcDate, date) => {
      const rangeKey = type === 'extremeSport' ? 'dateExtremeSportRange' : 'dateWinterSportRange';
      const startKey = type === 'extremeSport' ? 'startDateExtremeSport' : 'startDateWinterSport';
      const endKey = type === 'extremeSport' ? 'endDateExtremeSport' : 'endDateWinterSport';
      const range = traveler[rangeKey] || {};
      const update = isStart
        ? {[startKey]: utcDate, ...(range[endKey] && date.isAfter(range[endKey]) ? {[endKey]: null} : {})}
        : {[endKey]: utcDate};

      return updateNestedTraveler(formikValues.travelers, traveler, rangeKey, update);
    };

    const updateDatePicker = (type, StartOrEnd, dateinput, traveler) => {
      let date = moment(dateinput);
      const isStart = StartOrEnd === 'start';
      if (!date.isValid()) {
        formikSetField('travelers', updateSportDateRange(traveler, type, isStart, null, date));
        return;
      }
      if (StartOrEnd === 'start' && (
        date.isBefore(moment(formikValues.policyStartDate), 'day') ||
        date.isAfter(moment(formikValues.policyEndDate), 'day')
      )) {
        date = moment(formikValues.policyStartDate);
      } else if (StartOrEnd === 'end' && (
        date.isAfter(moment(formikValues.policyEndDate), 'day') ||
        date.isBefore(moment(formikValues.policyStartDate), 'day')
      )) {
        date = moment(formikValues.policyEndDate);
      }

      const utcDate = convertToUTCDate(date);

      if (type === 'extremeSport' || type === 'winterSport') {
        updateSportDateRange(traveler, type, isStart, utcDate, date);
      }

      formikSetField('travelers', formikValues.travelers);
    };

    // Save travelers to sessionStorage when leaving Tab 4
    useEffect(() => () => {
      sessionStorage.setItem('travelers', JSON.stringify(formikValues.travelers));
    }, [formikValues.travelers]);

    // Restore travelers from sessionStorage when Tab 4 is loaded
    useEffect(() => {
      const savedTravelers = sessionStorage.getItem('travelers');
      const travelers = savedTravelers ? JSON.parse(savedTravelers) : formikValues.travelers;
      formikSetField(
        'travelers',
        clampDateRangesToPolicy(travelers, formikValues.policyStartDate, formikValues.policyEndDate),
      );
    }, [formikSetField]);

    const handleLogicForShowingSuggestionAddRiderModal = () => {
      const todayDate = moment();
      const policyStartDate = moment(formikValues.policyStartDate);
      const isPassMonth = policyStartDate.diff(todayDate, 'days') + 1 >= 30;

      if (isPassMonth && !formikValues.isTravelsc) {
        fireGtmEvent('coversCancellationPu', {});
        setTypeOfSuggestionAddRiderModal('short_and_cancel');
        openSuggestionAddRiderModal();
        setShouldShowPopUp(false);
      } else if (!formikValues.isCharger) {
        fireGtmEvent('coversLuggagePu', {});
        setShouldShowPopUp(false);
        setTypeOfSuggestionAddRiderModal('luggage');
        openSuggestionAddRiderModal();
      } else {
        submitCallback(5);
      }
    };

    const handleSuggestionAddRiderModalConfirm = async () => {
      if (isSuggestionSubmitting) return;
      setIsSuggestionSubmitting(true);
      let updatedValues = formikValues;
      if (typeOfSuggestionAddRiderModal === 'luggage') {
        fireGtmEvent('addCoversLuggagePu', {});
        setIsCharger(true);
        await formikSetField('isCharger', true);
        updatedValues = {...formikValues, isCharger: true};
      }
      if (typeOfSuggestionAddRiderModal === 'short_and_cancel') {
        fireGtmEvent('addCoversCancellationPu', {});
        setIsTravelsc(true);
        await formikSetField('isTravelsc', true);
        updatedValues = {...formikValues, isTravelsc: true};
      }
      setDetailForm({values: updatedValues});
      closeSuggestionAddRiderModal();
      submitCallback(5);
    };

    const handleSuggestionAddRiderModalDecline = () => {
      if (isSuggestionSubmitting) return;
      setIsSuggestionSubmitting(true);
      closeSuggestionAddRiderModal();
      submitCallback(5);
    };

    const clickDateWinterSport = (traveler, value) => {
      const range = traveler.dateWinterSportRange || {};
      formikSetField('travelers', updateTraveler(formikValues.travelers, traveler, {
        needDateWinterSport: value,
        dateWinterSportRange: value ? {
          ...range,
          startDateWinterSport: range.startDateWinterSport || convertToUTCDate(moment(formikValues.policyStartDate)),
          endDateWinterSport: range.endDateWinterSport || convertToUTCDate(moment(formikValues.policyEndDate)),
        } : {},
      }));
    };

    const clickDateExtremeSport = (traveler, value) => {
      const range = traveler.dateExtremeSportRange || {};
      formikSetField('travelers', updateTraveler(formikValues.travelers, traveler, {
        needDateExtremeSport: value,
        dateExtremeSportRange: value ? {
          ...range,
          startDateExtremeSport: range.startDateExtremeSport || convertToUTCDate(moment(formikValues.policyStartDate)),
          endDateExtremeSport: range.endDateExtremeSport || convertToUTCDate(moment(formikValues.policyEndDate)),
        } : {},
      }));
    };

    const clickPcCoverage = (traveler, value) => {
      formikSetField('travelers', updateTraveler(formikValues.travelers, traveler, {
        needPcCoverage: value,
        pc: value ? {...(traveler.pc || {})} : {},
      }));
    };

    const clickMobileCoverage = (traveler, value) => {
      formikSetField('travelers', updateTraveler(formikValues.travelers, traveler, {
        needMobileCoverage: value,
        mobile: value ? {...(traveler.mobile || {})} : {},
      }));
    };

    const clickCancellationOfSelfParticipationOnRentedCar = (traveler, value) => {
      formikSetField('travelers', selectExclusiveTraveler(
        formikValues.travelers,
        traveler,
        'cancellationOfSelfParticipationOnRentedCar',
        value,
      ));
    };

    const handleSubmit = async () => {
      setShowValidationErrors(true);
      const errors = await formikValidateForm();
      if (Object.keys(errors).length === 0) {
        if (isPregnancyAndExtremeSportsStatus && !isApprovedPregnancyAndExtremeSports &&
          formikValues?.isPregnancy === 'yes') {
          setIsShowPregnancyAndExtremeSportsPopup(true);
          return;
        }

        fireGtmEvent('confirmAdditionalCovers', {
          locateAndExtract: formikValues.isDetection,
          travelThirdParty: formikValues.isLiable,
          luggage: formikValues.isCharger,
          extreme: formikValues.isEsports,
          winterExtreme: formikValues.isWsports,
          cancellation: formikValues.isTravelc,
          shortening: formikValues.isTravelsc,
          pcAndTablet: formikValues.isPccover,
          mobile: formikValues.isMobilecover,
          cancellationOfSelfParticipationOnRentedCar: formikValues.isCancellationOfSelfParticipationOnRentedCar,
        });
        if (shouldShowPopUp) {
          handleLogicForShowingSuggestionAddRiderModal();
        } else {
          submitCallback(5);
        }
      } else {
        scrollToFirstError(errors);
      }
    };

    // Extension state
    const [isCharger, setIsCharger] = React.useState(false);
    const [isApprovedPregnancyAndExtremeSports, setIsApprovedPregnancyAndExtremeSports] = React.useState(false);
    const [isShowPregnancyAndExtremeSportsPopup, setIsShowPregnancyAndExtremeSportsPopup] = React.useState(false);
    const [typeOfShowPregnancyAndExtremeSportsPopup, setTypeOfShowPregnancyAndExtremeSportsPopup] = React.useState('pregnancy_and_extreme_sports_both.title');
    const [isEsports, setIsEsports] = React.useState(false);
    const [isWsports, setIsWsports] = React.useState(false);
    const [isTravelc, setIsTravelc] = React.useState(false);
    const [isTravelsc, setIsTravelsc] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const [isPccover, setIsPccover] = React.useState(false);
    const [isMobilecover, setIsMobilecover] = React.useState(false);

    let isPregnancyAndExtremeSportsStatus = false;
    const isPregnancy = formikValues?.isPregnancy;
    if (isPregnancy === 'yes' && isEsports || isWsports) {
      isPregnancyAndExtremeSportsStatus = true;
    }

    // Sync local state from Formik values on mount
    React.useEffect(() => {
      if (formikValues.isDetection && !isDetection) setIsDetection(true);
      if (formikValues.isLiable && !isLiable) setIsLiable(true);
      if (formikValues.isCharger && !isCharger) setIsCharger(true);
      if (formikValues.isEsports && !isEsports) setIsEsports(true);
      if (formikValues.isWsports && !isWsports) setIsWsports(true);
      if (formikValues.isTravelsc && !isTravelsc) setIsTravelsc(true);
      if (formikValues.isPccover && !isPccover) setIsPccover(true);
      if (formikValues.isMobilecover && !isMobilecover) setIsMobilecover(true);
      if (formikValues.isCancellationOfSelfParticipationOnRentedCar && !isCancellationOfSelfParticipationOnRentedCar) setIsCancellationOfSelfParticipationOnRentedCar(true);
    }, []);

    const updateTravelCoverItems = (event, index, key, itemToCover) => {
      formikSetField('travelers', updateNestedTraveler(
        formikValues.travelers, index, itemToCover, {[key]: event.target.value},
      ));
    };

    const handleDeviceUpdate = (index, key, itemKey, value) => {
      formikSetField('travelers', updateNestedTraveler(
        formikValues.travelers, index, itemKey, {[key]: value},
      ));
    };

    const renderDatePickerRangeTraveler = (traveler, type) => {
      if (!traveler) return null;
      const minDate = toIsoDateValue(formikValues.policyStartDate);
      const maxDate = toIsoDateValue(formikValues.policyEndDate);

      if (type === 'extremeSport') {
        if (!traveler.needDateExtremeSport) return null;
        const startIso = toIsoDateValue(traveler.dateExtremeSportRange?.startDateExtremeSport);
        const endIso = toIsoDateValue(traveler.dateExtremeSportRange?.endDateExtremeSport);
        return (
          <div>
            <TripDatePicker
              selectionMode='independent'
              startValue={startIso}
              endValue={endIso}
              minDate={minDate}
              maxStartDate={maxDate}
              maxEndDate={maxDate}
              onStartChange={(iso) => updateDatePicker('extremeSport', 'start', iso, traveler)}
              onEndChange={(iso) => iso && updateDatePicker('extremeSport', 'end', iso, traveler)}
              startLabel={intl.formatMessage({id: 'coverage.startDate'})}
              endLabel={intl.formatMessage({id: 'coverage.endDate'})}
            />
            {startIso && endIso && (
              <div style={{textAlign: 'center', fontSize: theme.typography.pxToRem(14), color: theme.palette.text.secondary, marginTop: 6}}>
                <FormattedMessage id='step1.tab1.days_num_winter_extreme_sports' values={{
                  number: <b>{calculateDaysChange(moment(startIso), moment(endIso))}</b>,
                }} />
              </div>
            )}
          </div>
        );
      }

      // winterSport
      if (!traveler.needDateWinterSport) return null;
      const startIso = toIsoDateValue(traveler.dateWinterSportRange?.startDateWinterSport);
      const endIso = toIsoDateValue(traveler.dateWinterSportRange?.endDateWinterSport);
      return (
        <div>
          <TripDatePicker
            selectionMode='independent'
            startValue={startIso}
            endValue={endIso}
            minDate={minDate}
            maxStartDate={maxDate}
            maxEndDate={maxDate}
            onStartChange={(iso) => updateDatePicker('winterSport', 'start', iso, traveler)}
            onEndChange={(iso) => iso && updateDatePicker('winterSport', 'end', iso, traveler)}
            startLabel={intl.formatMessage({id: 'coverage.startDate'})}
            endLabel={intl.formatMessage({id: 'coverage.endDate'})}
          />
          {startIso && endIso && (
            <div style={{textAlign: 'center', fontSize: theme.typography.pxToRem(14), color: theme.palette.text.secondary, marginTop: 6}}>
              <FormattedMessage id='step1.tab1.days_num_winter_extreme_sports' values={{
                number: <b>{calculateDaysChange(moment(startIso), moment(endIso))}</b>,
              }} />
            </div>
          )}
        </div>
      );
    };

    // Hospitalization modal for cancellation/shortening
    const handleModalClose = (doCancel) => {
      if (doCancel) {
        setIsTravelsc(false);
        formikSetField('isTravelsc', false);
        formikSetField('isOwnerHospital2', '');
        setDetailForm({values: {...formikValues, isTravelsc: false, isOwnerHospital2: ''}});
      }
      setOpenModal(false);
    };

    const handleBack = () => {
      submitCallback(2); // go back to medical tab
    };

    return (
      <div className={className} id={idForAccessibility} role='tabpanel'>
        <div style={{width: '100%', maxWidth: 820, display: 'flex', flexDirection: 'column', alignItems: 'stretch', margin: '0 auto', padding: isMobile ? '14px 0 120px' : 'clamp(14px,2vw,22px) 0'}}>
        {/* Page title */}
        <h1 style={{
          margin: '0 auto 4px',
          fontWeight: theme.typography.fontWeightBlack,
          fontSize: theme.typography.pxToRem(isMobile ? 26 : 34),
          letterSpacing: 0,
          color: theme.palette.secondary.main,
          lineHeight: 1.15,
          textAlign: 'center',
        }}>
          <FormattedMessage id='coverage.heading'/>
          <span data-testid='coverage-heading-dot' aria-hidden='true' style={{
            display: 'inline-block',
            width: '0.24em',
            height: '0.24em',
            borderRadius: '50%',
            background: theme.palette.primary.dark,
            marginInlineStart: '0.08em',
          }}/>
        </h1>
        <p style={{
          margin: '10px auto 0',
          fontSize: theme.typography.pxToRem(isMobile ? 15 : 17),
          color: theme.palette.text.secondary,
          lineHeight: 1.5,
          textAlign: 'center',
          maxWidth: 560,
        }}>
          <FormattedMessage id='coverage.subtitle'/>
        </p>

        {/* Basic coverage package card */}
        <Card variant="raised" padding="lg" style={{marginTop: 22}}>
          <CoverageBasicPackage
            removedCovers={{isDetection: formikValues.isDetection === false, isLiable: formikValues.isLiable === false}}
            onToggleCover={(field) => {
              formikSetField(field, formikValues[field] === false);
            }}
          />
        </Card>

        {/* Extensions card */}
        <Card variant="raised" padding="lg" style={{marginTop: 18}}>
          <CoverageExtensionsList>
            {/* Luggage */}
            <CoverageExtensionRow
              icon={RIDER_DISPLAY.luggage.icon}
              title={intl.formatMessage({id: RIDER_DISPLAY.luggage.titleId})}
              description={intl.formatMessage({id: 'step1.tab5.charger_fulltext'})}
              price={RIDER_DISPLAY.luggage.price}
              recommended={intl.formatMessage({id: 'coverage.recommendedPeaceOfMind'})}
              checked={formikValues[RIDER_DISPLAY.luggage.formikKey]}
              onToggle={() => {
                const next = !formikValues[RIDER_DISPLAY.luggage.formikKey];
                setIsCharger(next);
                formikSetField(RIDER_DISPLAY.luggage.formikKey, next);
              }}
              testId={RIDER_DISPLAY.luggage.testId}
              last={false}
            />

            {/* Extreme sport */}
            <CoverageExtensionRow
              icon={RIDER_DISPLAY.extremeSport.icon}
              title={intl.formatMessage({id: RIDER_DISPLAY.extremeSport.titleId})}
              description={intl.formatMessage({id: 'step1.tab5.esports_fulltext'})}
              price={RIDER_DISPLAY.extremeSport.price}
              checked={formikValues[RIDER_DISPLAY.extremeSport.formikKey]}
              onToggle={() => {
                const next = !formikValues[RIDER_DISPLAY.extremeSport.formikKey];
                const isPreg = formikValues?.isPregnancy;
                if (isPreg === 'yes' && next) {
                  setIsShowPregnancyAndExtremeSportsPopup(true);
                  setTypeOfShowPregnancyAndExtremeSportsPopup('pregnancy_and_extreme_sports_esports.title');
                }
                if (formikValues.travelers.length === 1) {
                  clickDateExtremeSport(formikValues.travelers[0], next);
                }
                if (!next && formikValues.travelers.length > 1) {
                  formikSetField('travelers', updateAllTravelers(formikValues.travelers, {
                    needDateExtremeSport: false,
                    dateExtremeSportRange: {},
                  }));
                }
                setIsEsports(next);
                formikSetField(RIDER_DISPLAY.extremeSport.formikKey, next);
                if (!next && !isWsports) { setIsApprovedPregnancyAndExtremeSports(false); }
              }}
              testId={RIDER_DISPLAY.extremeSport.testId}
              last={false}
            >
              {/* Multi-traveler date selection */}
              {formikValues.travelers.length > 1 && formikValues[RIDER_DISPLAY.extremeSport.formikKey] && isEsports && formikValues.travelers.map((traveler, i) => (
                traveler.gender === 1 ? null : (
                  <div key={`traveler-${i}-extremeSport`} style={{width: '100%', marginTop: 8}}>
                    <FormControlLabel
                      label={traveler.fullName}
                      aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.pccover_ariaLabel'})}`}
                      control={<MuiCheckbox
                        name='traveler-DateExtremeSport'
                        data-testid={`traveler-${i + 1}-DateExtremeSport`}
                        checked={Boolean(traveler.needDateExtremeSport)}
                        onChange={(event, value) => {
                          formikSetField(`traveler-${i}-DateExtremeSport`, value);
                          clickDateExtremeSport(traveler, value);
                        }}
                      />}
                    />
                    <div>{renderDatePickerRangeTraveler(traveler, 'extremeSport')}</div>
                  </div>
                )
              ))}
              {formikValues.travelers.length === 1 && renderDatePickerRangeTraveler(formikValues.travelers[0], 'extremeSport')}
              {formikValues.travelers.length > 1 && <FormHelperText component='span' error>{visibleFormikErrors.dateExtremeSportRangeError}</FormHelperText>}
            </CoverageExtensionRow>

            {/* Winter sport */}
            <CoverageExtensionRow
              icon={RIDER_DISPLAY.winterSport.icon}
              title={intl.formatMessage({id: RIDER_DISPLAY.winterSport.titleId})}
              description={intl.formatMessage({id: 'step1.tab5.wsports_fulltext'})}
              price={RIDER_DISPLAY.winterSport.price}
              checked={formikValues[RIDER_DISPLAY.winterSport.formikKey]}
              onToggle={() => {
                const next = !formikValues[RIDER_DISPLAY.winterSport.formikKey];
                const isPreg = formikValues?.isPregnancy;
                if (isPreg === 'yes' && next) {
                  setTypeOfShowPregnancyAndExtremeSportsPopup('pregnancy_and_extreme_sports_wsports.title');
                  setIsShowPregnancyAndExtremeSportsPopup(true);
                }
                if (formikValues.travelers.length === 1) {
                  clickDateWinterSport(formikValues.travelers[0], next);
                } else if (!next && formikValues.travelers.length > 1) {
                  formikSetField('travelers', updateAllTravelers(formikValues.travelers, {
                    needDateWinterSport: false,
                    dateWinterSportRange: {},
                  }));
                }
                setIsWsports(next);
                if (!isEsports && !next) { setIsApprovedPregnancyAndExtremeSports(false); }
                formikSetField(RIDER_DISPLAY.winterSport.formikKey, next);
              }}
              testId={RIDER_DISPLAY.winterSport.testId}
              last={false}
            >
              {formikValues.travelers.length > 1 && formikValues[RIDER_DISPLAY.winterSport.formikKey] && isWsports && formikValues.travelers.map((traveler, i) => (
                traveler.gender === 1 ? null : (
                  <div key={`traveler-${i}-winterSport`} style={{width: '100%', marginTop: 8}}>
                    <FormControlLabel
                      label={traveler.fullName}
                      aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.pccover_ariaLabel'})}`}
                      control={<MuiCheckbox
                        name='traveler-DateWinterSport'
                        data-testid={`traveler-${i + 1}-DateWinterSport`}
                        checked={Boolean(traveler.needDateWinterSport)}
                        onChange={(event, value) => {
                          formikSetField(`traveler-${i}-DateWinterSport`, value);
                          clickDateWinterSport(traveler, value);
                        }}
                      />}
                    />
                    <div>{renderDatePickerRangeTraveler(traveler)}</div>
                  </div>
                )
              ))}
              {formikValues.travelers.length === 1 && renderDatePickerRangeTraveler(formikValues.travelers[0])}
              {formikValues.travelers.length > 1 && <FormHelperText component='span' error>{visibleFormikErrors.dateWinterSportError}</FormHelperText>}
            </CoverageExtensionRow>

            {/* Cancellation / shortening */}
            <CoverageExtensionRow
              icon={RIDER_DISPLAY.cancellation.icon}
              title={intl.formatMessage({id: RIDER_DISPLAY.cancellation.titleId})}
              description={intl.formatMessage({id: 'step1.tab5.travelsc_fulltext'})}
              price={RIDER_DISPLAY.cancellation.price}
              checked={formikValues[RIDER_DISPLAY.cancellation.formikKey]}
              onToggle={() => {
                const next = !formikValues[RIDER_DISPLAY.cancellation.formikKey];
                setIsTravelsc(next);
                formikSetField(RIDER_DISPLAY.cancellation.formikKey, next);
                formikSetField('isOwnerHospital2', '');
              }}
              testId={RIDER_DISPLAY.cancellation.testId}
              last={false}
            >
              {formikValues[RIDER_DISPLAY.cancellation.formikKey] && isTravelsc && (
                <div style={{marginTop: 8}}>
                  <div style={{fontSize: theme.typography.pxToRem(14.5), fontWeight: theme.typography.fontWeightSemiBold, color: theme.palette.text.primary, lineHeight: 1.5, textAlign: 'right', marginBottom: 12}}>
                    {intl.formatMessage({id: 'step1.tab5.travelc_bottom2_ask'})}
                  </div>
                  <SegmentedControl
                    ariaLabel={intl.formatMessage({id: 'step1.tab5.travelc_bottom2_ask'})}
                    value={formikValues.isOwnerHospital2}
                    options={[
                      {value: 'yes', label: intl.formatMessage({id: 'yes'})},
                      {value: 'no', label: intl.formatMessage({id: 'no'})},
                    ]}
                    onChange={(val, event) => {
                      event.stopPropagation();
                      formikSetField('isOwnerHospital2', val);
                      if (val === 'yes') { setOpenModal(true); }
                    }}
                  />
                  {visibleFormikErrors.isOwnerHospital2 && <FormHelperText component='span' error data-testid='isOwnerHospital2Error'>{visibleFormikErrors.isOwnerHospital2}</FormHelperText>}
                </div>
              )}
            </CoverageExtensionRow>

            {/* PC / Tablet */}
            <CoverageExtensionRow
              icon={RIDER_DISPLAY.pc.icon}
              title={intl.formatMessage({id: RIDER_DISPLAY.pc.titleId})}
              description={intl.formatMessage({id: 'step1.tab5.pccover_fulltext'})}
              price={RIDER_DISPLAY.pc.price}
              checked={formikValues[RIDER_DISPLAY.pc.formikKey]}
              onToggle={() => {
                const next = !formikValues[RIDER_DISPLAY.pc.formikKey];
                setIsPccover(next);
                if (formikValues.travelers.length === 1) {
                  clickPcCoverage(formikValues.travelers[0], next);
                } else if (formikValues.travelers.length > 1 && !next) {
                  formikSetField('travelers', updateAllTravelers(formikValues.travelers, {
                    needPcCoverage: false,
                    pc: {},
                  }));
                }
                formikSetField(RIDER_DISPLAY.pc.formikKey, next);
              }}
              testId={RIDER_DISPLAY.pc.testId}
              last={false}
            >
              {isPccover && formikValues.travelers.map((traveler, i) => (
                traveler.gender === 1 ? null : (
                  <div key={`traveler-${i}-pc`}>
                    {formikValues.travelers.length > 1 && (
                      <FormControlLabel
                        label={traveler.fullName}
                        aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.pccover_ariaLabel'})}`}
                        control={<MuiCheckbox
                          name='traveler-pcCover'
                          data-testid={`traveler-${i + 1}-pcCover`}
                          checked={Boolean(traveler.needPcCoverage)}
                          onChange={(event, value) => {
                            formikSetField(`traveler-${i}-pcCover`, value);
                            clickPcCoverage(traveler, value);
                          }}
                        />}
                      />
                    )}
                    {traveler.needPcCoverage && traveler.pc && (
                      <DeviceFields
                        traveler={traveler}
                        index={i}
                        formikErrors={visibleFormikErrors}
                        onUpdate={handleDeviceUpdate}
                        showYear
                      />
                    )}
                  </div>
                )
              ))}
              {formikValues.travelers.length > 1 && <FormHelperText component='span' error>{visibleFormikErrors.pcCoverError}</FormHelperText>}
            </CoverageExtensionRow>

            {/* Mobile phone */}
            <CoverageExtensionRow
              icon={RIDER_DISPLAY.mobile.icon}
              title={intl.formatMessage({id: RIDER_DISPLAY.mobile.titleId})}
              description={intl.formatMessage({id: 'step1.tab5.mobilecover_fulltext'})}
              price={RIDER_DISPLAY.mobile.price}
              checked={formikValues[RIDER_DISPLAY.mobile.formikKey]}
              onToggle={() => {
                const next = !formikValues[RIDER_DISPLAY.mobile.formikKey];
                setIsMobilecover(next);
                if (formikValues.travelers.length === 1) {
                  clickMobileCoverage(formikValues.travelers[0], next);
                }
                if (formikValues.travelers.length > 1 && !next) {
                  formikSetField('travelers', updateAllTravelers(formikValues.travelers, {
                    needMobileCoverage: false,
                    mobile: {},
                  }));
                }
                formikSetField(RIDER_DISPLAY.mobile.formikKey, next);
              }}
              testId={RIDER_DISPLAY.mobile.testId}
              last={!RIDER_DISPLAY.rentalCar.isEligible(formikValues.travelers)}
            >
              {isMobilecover && formikValues.travelers.map((traveler, i) => (
                traveler.gender === 1 ? null : (
                  <div key={`traveler-${i}-mobile`}>
                    {formikValues.travelers.length > 1 && (
                      <FormControlLabel
                        label={traveler.fullName}
                        aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.mobilecover_ariaLabel'})}`}
                        control={<MuiCheckbox
                          name={`traveler-${i}-mobileCover`}
                          data-testid={`traveler-${i + 1}-mobileCover`}
                          checked={Boolean(traveler.needMobileCoverage)}
                          onChange={(event, value) => { clickMobileCoverage(traveler, value); }}
                        />}
                      />
                    )}
                    {traveler.needMobileCoverage && traveler.mobile && (
                      <DeviceFields
                        traveler={traveler}
                        index={i}
                        formikErrors={visibleFormikErrors}
                        onUpdate={handleDeviceUpdate}
                        showYear={false}
                      />
                    )}
                  </div>
                )
              ))}
              {formikValues.travelers.length > 1 && <FormHelperText component='span' error>{visibleFormikErrors.mobileCoverError}</FormHelperText>}
            </CoverageExtensionRow>

            {/* Rented car self-participation — only if any traveler age >= 24 */}
            {RIDER_DISPLAY.rentalCar.isEligible(formikValues.travelers) && (
              <CoverageExtensionRow
                icon={RIDER_DISPLAY.rentalCar.icon}
                title={intl.formatMessage({id: RIDER_DISPLAY.rentalCar.titleId})}
                description={intl.formatMessage({id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar_fulltext'})}
                price={RIDER_DISPLAY.rentalCar.price}
                checked={formikValues[RIDER_DISPLAY.rentalCar.formikKey]}
                onToggle={() => {
                  const next = !formikValues[RIDER_DISPLAY.rentalCar.formikKey];
                  setIsCancellationOfSelfParticipationOnRentedCar(next);
                  let indexOfTraveler;
                  for (let i = 0; i < formikValues.travelers.length; i++) {
                    if (RIDER_DISPLAY.rentalCar.isTravelerEligible(formikValues.travelers[i])) {
                      if (indexOfTraveler !== undefined) { indexOfTraveler = undefined; break; }
                      else { indexOfTraveler = i; }
                    }
                  }
                  if (formikValues.travelers.length === 1) {
                    clickCancellationOfSelfParticipationOnRentedCar(formikValues.travelers[0], next);
                  } else if (indexOfTraveler !== undefined) {
                    clickCancellationOfSelfParticipationOnRentedCar(formikValues.travelers[indexOfTraveler], next);
                  }
                  if (!next) {
                    formikSetField('travelers', updateAllTravelers(formikValues.travelers, {
                      cancellationOfSelfParticipationOnRentedCar: false,
                    }));
                  }
                  formikSetField(RIDER_DISPLAY.rentalCar.formikKey, next);
                }}
                testId={RIDER_DISPLAY.rentalCar.testId}
                last
              >
                {isCancellationOfSelfParticipationOnRentedCar && formikValues.travelers.length > 1 && (
                  <div style={{marginTop: 8}}>
                    <p style={{lineHeight: 1.5, marginBottom: '0.2rem', fontSize: theme.typography.pxToRem(13.5), color: theme.palette.text.primary}}>
                      {intl.formatMessage({id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar_explain_what_todo'})}
                    </p>
                    {formikValues.travelers.map((traveler, i) => (
                      !RIDER_DISPLAY.rentalCar.isTravelerEligible(traveler) ? null : (
                        <FormControlLabel
                          key={`traveler-${i}-car`}
                          label={traveler.fullName}
                          aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar_ariaLabel'})}`}
                          control={<MuiCheckbox
                            name={`traveler-${i}-cancellationOfSelfParticipationOnRentedCar`}
                            data-testid={`traveler-${i + 1}-cancellationOfSelfParticipationOnRentedCar`}
                            checked={Boolean(traveler.cancellationOfSelfParticipationOnRentedCar)}
                            onChange={(event, value) => { clickCancellationOfSelfParticipationOnRentedCar(traveler, value); }}
                          />}
                        />
                      )
                    ))}
                    <FormHelperText style={{margin: '10px'}} component='span' error>{visibleFormikErrors.isCancellationOfSelfParticipationOnRentedCarError}</FormHelperText>
                  </div>
                )}
              </CoverageExtensionRow>
            )}
          </CoverageExtensionsList>
        </Card>

        {/* Consent + Footer */}
        <CoverageConsentFooter
          onBack={handleBack}
          onSubmit={handleSubmit}
        />

        {/* Hospitalization warning modal */}
        <Dialog
          open={openModal}
          onClose={() => handleModalClose(true)}
          title={intl.formatMessage({id: 'step1.tab5.travelc_bottom2_notation'})}
          width={600}
          footer={<>
            <Button
              data-testid='cancel-cover-btn-modal'
              variant='secondary'
              onClick={() => handleModalClose(true)}
            >
              <FormattedMessage id='cancel'/>
            </Button>
            <Button
              data-testid='add-cover-btn-modal'
              variant='accent'
              onClick={() => handleModalClose(false)}
            >
              <FormattedMessage id='coverage.notice.add_cover'/>
            </Button>
          </>}
          style={{textAlign: 'right'}}
        >
          <p style={{fontSize: theme.typography.pxToRem(15), lineHeight: 1.6, color: theme.palette.text.secondary, margin: 0}}>
            {intl.formatMessage({id: 'step1.tab5.travelc_bottom2_notation2'})}
          </p>
        </Dialog>

        {/* Suggestion add rider modal */}
        {/* Pregnancy + extreme sports popup — always mounted, controlled via isOpen */}
        <PregnancyAndExtremeSportsPopup
          typeOfShowPregnancyAndExtremeSportsPopup={typeOfShowPregnancyAndExtremeSportsPopup}
          isOpen={isShowPregnancyAndExtremeSportsPopup}
          onClose={setIsShowPregnancyAndExtremeSportsPopup}
          onCheckBoxEvent={setIsApprovedPregnancyAndExtremeSports}
          sportsStatus={{isEsports, isWsports}}
        />
        <BaggageCoverageOfferModal
          open={showSuggestionAddRiderModal && typeOfSuggestionAddRiderModal === 'luggage'}
          price={RIDER_DISPLAY.luggage.price}
          travelerCount={formikValues.travelers.length}
          dayCount={calculateDaysChange(moment(formikValues.policyStartDate), moment(formikValues.policyEndDate))}
          loading={isSuggestionSubmitting}
          onAdd={handleSuggestionAddRiderModalConfirm}
          onDecline={handleSuggestionAddRiderModalDecline}
        />
        {typeOfSuggestionAddRiderModal !== 'luggage' && (
          <SuggestionAddRiderModal
            isModalShow={showSuggestionAddRiderModal}
            title={intl.formatMessage({id: `step1.tab4.suggestion_add_rider_title_${typeOfSuggestionAddRiderModal}`})}
            description={intl.formatMessage({id: `step1.tab4.suggestion_add_rider_description_${typeOfSuggestionAddRiderModal}`})}
            subDescription={intl.formatMessage({id: `step1.tab4.suggestion_add_rider_subdescription_${typeOfSuggestionAddRiderModal}`})}
            onClose={closeSuggestionAddRiderModal}
            buttons={{
              button1: {
                image: presentorImage,
                text: intl.formatMessage({id: 'step1.tab4.suggestionAddRiderModal.button1'}),
                onClick: handleSuggestionAddRiderModalConfirm,
              },
              button2: {
                text: intl.formatMessage({id: 'step1.tab4.suggestionAddRiderModal.button2'}),
                onClick: handleSuggestionAddRiderModalDecline,
              },
            }}
          />
        )}
        </div>
      </div>
    );
  },
);

Tab4.propTypes = {
  className: PropTypes.string,
  intl: PropTypes.object,
  submitCallback: PropTypes.func,
  formikIsSubmitting: PropTypes.bool,
  validationCallback: PropTypes.func,
  formikSetField: PropTypes.func,
  formikErrors: PropTypes.object,
  formikValues: PropTypes.object,
  formikSetTouched: PropTypes.func,
  formikValidateForm: PropTypes.func,
  setFieldValue: PropTypes.func,
  isforBlock4: PropTypes.bool,
  actionButton: PropTypes.object,
  idForAccessibility: PropTypes.string,
  handleOtpOpen: PropTypes.func,
  showOTP: PropTypes.bool,
};

export default Tab4;
